import './label.scss';
import './label-loader';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/label/index.js